/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import type { User, UserAuth } from '@repo/common';
import constants from '../utils/constants';
import { getPrivateClient } from './common.data';

export const patchUser = async (
  $user: Partial<User>,
  $userAuthToken: Pick<UserAuth, 'idToken' | 'refreshToken'>
): Promise<User> => {
  const payload = {
    firstName: $user.firstName,
    lastName: $user.lastName,
    profile: $user.profile,
    notifications: $user.notifications
  };
  const client = getPrivateClient($userAuthToken, { timeout: constants.TIMEOUT_MEDIUM });
  console.log('sending payload: ', payload);
  const response = await client.patch(`/user`, payload);
  return response.data;
};

export const getUser = async (
  $userAuthToken: Pick<UserAuth, 'idToken' | 'refreshToken'>
): Promise<User> => {
  const client = getPrivateClient($userAuthToken, { timeout: constants.TIMEOUT_SHORT });
  const response = await client.get(`/user`);
  return response.data;
};
